enum Events {
	LOGIN = "LOGIN",
	LOGOUT = "LOGOUT",
	SET_LOGIN = "SET_LOGIN"
}

export default Events;